import { parseBoolean } from '@gitlab/frontend-utils';
import { initVueApp } from '../../../../../../app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import GroupActivityCard from './components/group_activity_card.vue?vue3';

export default () => {
  const container = document.getElementById('js-group-activity');

  if (!container) return;

  const {
    canReadBilling,
    showPlanIndicator,
    groupBillingsPath,
    groupSubscriptionPlanName,
    groupFullPath,
    mergeRequestsMetricLink,
    issuesMetricLink,
    newMembersMetricLink,
  } = container.dataset;

  initVueApp({
    el: container,
    name: 'GroupActivityCardRoot',
    provide: {
      canReadBilling: parseBoolean(canReadBilling),
      showPlanIndicator: parseBoolean(showPlanIndicator),
      groupBillingsPath,
      groupSubscriptionPlanName,
      groupFullPath,
      mergeRequestsMetricLink,
      issuesMetricLink,
      newMembersMetricLink,
    },
    component: GroupActivityCard,
  });
};
